import { InMemoryCache } from "@apollo/client/core";

export const aCache = new InMemoryCache({
  typePolicies: {

  }
});
